import { Button } from "@chakra-ui/button"
import { FormControl, FormErrorMessage } from "@chakra-ui/form-control"
import { Input, InputRightElement } from "@chakra-ui/input"
import { Box, Link, Text } from "@chakra-ui/layout"
import { Image, InputGroup } from "@chakra-ui/react"
import { Field, Form, Formik } from "formik"
import { useRef, useState } from "react"
import { useHistory } from "react-router"
import { registerUser } from "../../redux/api/apiCalls"
import { ReactComponent as Eye } from "../../svg/eye.svg";
import { ReactComponent as EyeSlash } from "../../svg/eyeSlash.svg";

export default function Register() {
    const passwordRef = useRef()
    const history = useHistory()
    const [firstNameError, setFirstNameError] = useState(null)
    const [lastNameError, setLastNameError] = useState(null)
    const [emailError, setEmailError] = useState(null)
    const [mobileNumberError, setMobileNumberError] = useState(null)
    const [passwordError, setPasswordError] = useState(null)
    const [confirmPasswordError, setConfirmPasswordError] = useState(null)
    const [showPassword, setShowPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)

    function validateFirstName(value) {
        if (firstNameError) {
            setFirstNameError(null)
        }
        let error
        if (!value) {
            error = "First Name is required"
        }
        if (/\d/.test(value)) {
            error = "First Name must not contain digits!"
        }
        if (/\W/.test(value)) {
            error = "First Name must not contain special characters"
        }
        return error
    }

    function validateLastName(value) {
        if (lastNameError) {
            setLastNameError(null)
        }
        let error
        if (!value) {
            error = "Last Name is required"
        }
        if (/\d/.test(value)) {
            error = "Last Name must not contain digits!"
        }
        if (/\W/.test(value)) {
            error = "Last Name must not contain special characters"
        }
        return error
    }

    function validateEmail(value) {
        if (emailError) {
            setEmailError(null)
        }
        let error
        if (!value) {
            error = "Email is required"
        }
        if (!/.+@.+\..{2,}/.test(value)) {
            error = "Please enter a valid email address!"
        }
        return error
    }

    function validateMobileNumber(value) {
        if (mobileNumberError) {
            setMobileNumberError(null)
        }
        let error
        if (!value) {
            error = "Mobile Number is required"
        }
        if (value.toString().length !== 10) {
            error = "Invalid Mobile Number"
        }
        if (/\D/i.test(value)) {
            if (!error) {
                error = "Only numerical digits are allowed!"
            }
        }
        return error
    }

    function validatePassword(value) {
        if (passwordError) {
            setPasswordError(null)
        }
        let error
        if (!value) {
            error = "Password is required"
        }
        if (value.toString().length < 8) {
            error = "Password must be atleast 8 characters long!"
        }
        return error
    }

    function validateConfirmPassword(value) {
        if (confirmPasswordError) {
            setConfirmPasswordError(null)
        }
        let error
        if (!value) {
            error = "Confirm Password is required"
        }
        if (passwordRef.current.value !== value.toString()) {
            error = "Confirm Password doesn't match password!"
        }
        return error
    }

    function keyPressHandler(e) {
        if (/\D/i.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') {
            e.preventDefault()
        }
    }

    function setErrorMessages(error) {
        console.log(error)
        if ("first_name" in error) {
            setFirstNameError(error.first_name[0])
        }
        if ("last_name" in error) {
            setLastNameError(error.last_name[0])
        }
        if ("email" in error) {
            console.log(error.email)
            setEmailError(error.email[0])
        }
        if ("mobile_no" in error) {
            setMobileNumberError(error.mobile_no[0])
        }
        if ("password" in error) {
            setPasswordError(error.password[0])
        }
        if ("confirmation_password" in error) {
            setConfirmPasswordError(error.confirmation_password[0])
        }
    }

    return (
        <Box
            w='100vw'
            minH='90vh'
            d='flex'
            justifyContent='center'
            alignItems='center'
            flexDir='column'
            mt='-5vh'
        >
            <Image src='./images/Logo.svg' width='300px' height='125px' objectFit='contain' />
            <Text
                fontSize={['16px', '22px', '26px', '30px']}
                fontWeight='700'
                style={{ fontFamily: 'Mulish, sans-serif' }}
                color="#222222"
                mb='2rem'
            >
                Sign Up
            </Text>

            <Formik
                initialValues={{
                    firstName: "",
                    lastName: "",
                    email: "",
                    mobileNumber: "",
                    password: "",
                    confirmPassword: ""
                }}
                onSubmit={async (values, actions) => {
                    let registerData = new FormData()
                    registerData.append("first_name", values.firstName)
                    registerData.append("last_name", values.lastName)
                    registerData.append("email", values.email)
                    registerData.append("mobile_no", values.mobileNumber)
                    registerData.append("password", values.password)
                    registerData.append("password_confirmation", values.confirmPassword)
                    try {
                        let response = await registerUser(registerData)
                        if (response) {
                            console.log("registered")
                            history.push('/login')
                        }
                    }
                    catch (error) {
                        setErrorMessages(error.response.data.message)
                    }
                    actions.setSubmitting(false)
                }}
            >
                {(props) => (
                    <Box
                        d='flex'
                        justifyContent='center'
                        alignItems='center'
                        w={['95%', '90%', '70%', '60%', '45%']}

                    >
                        <Form style={{ display: 'flex', width: '100%', flexDirection: 'column', padding: '0px 1rem', justifyContent: 'flex-start', alignItems: 'flex-start', gap: '1rem' }}>
                            <Box
                                d='flex'
                                width='100%'
                                flexDir={['column', 'column', 'row', 'row', 'row']}
                                style={{ gap: '1rem' }}
                            >
                                <Field name="firstName" validate={validateFirstName}>
                                    {({ field, form }) => (
                                        <FormControl isInvalid={(form.errors.firstName && form.touched.firstName) || firstNameError}>
                                            <Input
                                                {...field}
                                                type='text'
                                                fontSize='16px'
                                                fontWeight='600'
                                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                                borderRadius='10px'
                                                h='40px'
                                                border='1px solid rgba(0, 0, 0, 0.1)'
                                                bg='#fcfcfc'
                                                id="firstName"
                                                placeholder="First Name"
                                            />
                                            <FormErrorMessage>{form.errors.firstName || firstNameError}</FormErrorMessage>
                                        </FormControl>
                                    )}
                                </Field>

                                <Field name="lastName" validate={validateLastName}>
                                    {({ field, form }) => (
                                        <FormControl isInvalid={(form.errors.lastName && form.touched.lastName) || lastNameError}>
                                            <Input
                                                {...field}
                                                type='text'
                                                fontSize='16px'
                                                fontWeight='600'
                                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                                borderRadius='10px'
                                                h='40px'
                                                border='1px solid rgba(0, 0, 0, 0.1)'
                                                bg='#fcfcfc'
                                                id="lastName"
                                                placeholder="Last Name"
                                            />
                                            <FormErrorMessage>{form.errors.lastName || lastNameError}</FormErrorMessage>
                                        </FormControl>
                                    )}
                                </Field>
                            </Box>
                            <Field name="email" validate={validateEmail}>
                                {({ field, form }) => (
                                    <FormControl isInvalid={(form.errors.email && form.touched.email) || emailError}>
                                        <Input
                                            {...field}
                                            type='text'
                                            fontSize='16px'
                                            fontWeight='600'
                                            style={{ fontFamily: 'Mulish, sans-serif' }}
                                            borderRadius='10px'
                                            h='40px'
                                            border='1px solid rgba(0, 0, 0, 0.1)'
                                            bg='#fcfcfc'
                                            id="email"
                                            placeholder="Email Address"
                                        />
                                        <FormErrorMessage>{form.errors.email || emailError}</FormErrorMessage>
                                    </FormControl>
                                )}
                            </Field>

                            <Field name="mobileNumber" validate={validateMobileNumber}>
                                {({ field, form }) => (
                                    <FormControl isInvalid={(form.errors.mobileNumber && form.touched.mobileNumber) || mobileNumberError}>
                                        <Input
                                            {...field}
                                            type='number'
                                            fontSize='16px'
                                            fontWeight='600'
                                            style={{ fontFamily: 'Mulish, sans-serif' }}
                                            borderRadius='10px'
                                            h='40px'
                                            border='1px solid rgba(0, 0, 0, 0.1)'
                                            bg='#fcfcfc'
                                            id="mobileNumber"
                                            placeholder="Mobile Number"
                                            onKeyDown={keyPressHandler}
                                        />
                                        <FormErrorMessage>{form.errors.mobileNumber || mobileNumberError}</FormErrorMessage>
                                    </FormControl>
                                )}
                            </Field>

                            <Field name="password" validate={validatePassword}>
                                {({ field, form }) => (
                                    <FormControl isInvalid={(form.errors.password && form.touched.password) || passwordError}>
                                        <InputGroup>
                                            <Input
                                                {...field}
                                                type={showPassword ? 'text' : 'password'}
                                                fontSize='16px'
                                                fontWeight='600'
                                                style={{ fontFamily: 'Mulish, sans-serif' }}
                                                borderRadius='10px'
                                                h='40px'
                                                border='1px solid rgba(0, 0, 0, 0.1)'
                                                bg='#fcfcfc'
                                                id="password"
                                                placeholder="Password"
                                                ref={passwordRef}
                                            />
                                            <InputRightElement
                                                children={showPassword ? <EyeSlash /> : <Eye />}
                                                cursor='pointer'
                                                height='100%'
                                                onClick={() => setShowPassword(!showPassword)}
                                            />
                                        </InputGroup>
                                        <FormErrorMessage>{form.errors.password || passwordError}</FormErrorMessage>
                                    </FormControl>
                                )}
                            </Field>

                            <Field name="confirmPassword" validate={validateConfirmPassword}>
                                {({ field, form }) => (
                                    <FormControl isInvalid={(form.errors.confirmPassword && form.touched.confirmPassword) || confirmPasswordError}>
                                        <InputGroup>
                                        <Input
                                            {...field}
                                            type={showConfirmPassword ? 'text':'password'}
                                            fontSize='16px'
                                            fontWeight='600'
                                            style={{ fontFamily: 'Mulish, sans-serif' }}
                                            borderRadius='10px'
                                            h='40px'
                                            border='1px solid rgba(0, 0, 0, 0.1)'
                                            bg='#fcfcfc'
                                            id="confirmPassword"
                                            placeholder="Re-enter Password"
                                        />
                                         <InputRightElement
                                                children={showConfirmPassword ? <EyeSlash /> : <Eye />}
                                                cursor='pointer'
                                                height='100%'
                                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                            />
                                        </InputGroup>
                                        <FormErrorMessage>{form.errors.confirmPassword || confirmPasswordError}</FormErrorMessage>
                                    </FormControl>
                                )}
                            </Field>
                            <Box
                                d='flex'
                                justifyContent='center'
                                alignItems='center'
                                w='100%'
                            >
                                <Button
                                    mt={4}
                                    bg='linear-gradient(90.57deg, #7B90F7 3.35%, #3E59DE 94.78%)'
                                    _hover={{ bg: 'linear-gradient(90.57deg, #6e81dd 3.35%, #3750c6 94.78%)' }}
                                    boxShadow='0px 4px 8px rgba(0, 0, 0, 0.1)'
                                    borderRadius='7px'
                                    loadingText='Registering...'
                                    isLoading={props.isSubmitting}
                                    fontSize='18px'
                                    fontWeight='900'
                                    style={{ fontFamily: 'Mulish, sans-serif' }}
                                    color="#ffffff"
                                    type="submit"
                                    w='100%'
                                    h='40px'
                                >
                                    Register
                                </Button>
                            </Box>
                        </Form>
                    </Box>
                )}
            </Formik>
            <Box
                d='flex'
                fontSize='16px'
                fontWeight='500'
                style={{ fontFamily: 'Mulish, sans-serif' }}
                color="#222222"
                mt='1rem'
            >
                <Text mr='1'>Already have an account?</Text>
                <Link href='/login'>Log In</Link>
            </Box>
        </Box>
    )
}